import { render, staticRenderFns } from "./SankeyDiagram.vue?vue&type=template&id=e8c09cda&scoped=true"
import script from "./SankeyDiagram.vue?vue&type=script&lang=js"
export * from "./SankeyDiagram.vue?vue&type=script&lang=js"
import style0 from "./SankeyDiagram.vue?vue&type=style&index=0&id=e8c09cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8c09cda",
  null
  
)

export default component.exports